import { ReactNode } from 'react'

import cn from 'classnames'

import styles from './styles.module.scss'

const PopupHeading = ({ children, className }: { children: ReactNode; className?: string }) => {
  return <h2 className={cn(styles.popup__heading, className)}>{children}</h2>
}

export default PopupHeading
